import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

interface NavItem {
  label: string;
  to: string;
}

interface NavbarProps {
  navigation?: unknown;
}

const navLinks: NavItem[] = [
  { label: 'الرئيسية', to: '/' },
  { label: 'من أنا', to: '/about' },
  { label: 'أعمالي', to: '/works' },
  { label: 'منهجية العمل', to: '/approach' },
];

const Navbar: React.FC<NavbarProps> = () => {
  const { pathname, hash } = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isActive = (path: string) => (path === '/' ? pathname === '/' : pathname.startsWith(path));

  useEffect(() => {
    setIsMenuOpen(false);
  }, [pathname, hash]);

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-profile">
          <div className="navbar-avatar">
            <img src="/Image.png" alt="فيصل القحطاني" />
          </div>
          <div className="navbar-profile-text">
            <span className="navbar-profile-name">فيصل القحطاني</span>
            <span className="navbar-profile-title">مهندس برمجيات</span>
          </div>
        </Link>

        <ul className="navbar-links">
          {navLinks.map((item) => (
            <li key={item.to}>
              <Link
                to={item.to}
                className={`navbar-link ${isActive(item.to) ? 'is-active' : ''}`}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="navbar-actions">
          <Link to="/#contact" className="navbar-cta">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
              <rect x="1.75" y="3" width="10.5" height="8" rx="1.17" stroke="white" strokeWidth="1.33" />
              <path d="M2 4L7 7.5L12 4" stroke="white" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span>تواصل معي</span>
          </Link>
          <button
            type="button"
            className={`navbar-menu-toggle ${isMenuOpen ? 'is-open' : ''}`}
            aria-label={isMenuOpen ? 'إغلاق القائمة' : 'فتح القائمة'}
            aria-expanded={isMenuOpen}
            aria-controls="navbar-mobile-menu"
            onClick={() => setIsMenuOpen((open) => !open)}
          >
            <span className="navbar-menu-toggle-bar" />
            <span className="navbar-menu-toggle-bar" />
            <span className="navbar-menu-toggle-bar" />
          </button>
        </div>
      </div>

      <div
        id="navbar-mobile-menu"
        className={`navbar-mobile ${isMenuOpen ? 'is-open' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-hidden={!isMenuOpen}
      >
        <ul className="navbar-mobile-links">
          {navLinks.map((item) => (
            <li key={item.to}>
              <Link
                to={item.to}
                className={`navbar-mobile-link ${isActive(item.to) ? 'is-active' : ''}`}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <button
        type="button"
        className={`navbar-backdrop ${isMenuOpen ? 'is-open' : ''}`}
        aria-label="إغلاق القائمة"
        tabIndex={isMenuOpen ? 0 : -1}
        onClick={() => setIsMenuOpen(false)}
      />
    </nav>
  );
};

export default Navbar;
